/**
 * @sort id
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
    },
    {
        text: 'rut',
        value: 'sl_customer_rut',
        format: 'rut',
    },
    {
        text: 'cliente',
        value: 'sl_customer_alias_name',
    },
    {
        text: 'vendedor',
        value: 'g_seller_user_full_name',
    },
    {
        text: 'tipo',
        value: 'pos_sale_type_name',
        align: 'center',
        component: {
            type: 'chip',
            custom: 'has_pos_sale_type_id',
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: 'black',
            },
        },
    },
    {
        text: 'orden',
        value: 'invoiceDataPurchaseOrder',
    },
    {
        text: 'creación',
        value: 'created_at',
        format: 'datetime',
        align: 'right',
    },
    {
        text: 'estado',
        value: 'g_state_name',
        align: 'center',
        component: {
            type: 'chip',
            custom: 'has_g_state',
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: 'black',
            },
        },
    },
    {
        text: 'total',
        value: 'invoice_total',
        format: 'currency',
        align: 'right',
        active: true,
    },
]
